import { apiClient } from "@/services/api";

export const createProduct = async (productData) => {
  try {
    const response = await apiClient.post(`/api/sale/product`, productData);
    return response.data;
  } catch (error) {
    console.error("Erro ao criar o produto:", error);
    throw new Error("Erro ao criar o produto");
  }
};

export const listProducts = async (filters = {}, token = null) => {
  try {
    const params = {
      "filters[pointOfSaleId]": filters.pointOfSaleId,
      "filters[id]": filters.id,
      "filters[productImages]": filters.productImages ?? "url",
      "filters[categoryType]": filters.categoryType,
      forDashboard: filters.forDashboard,
    };

    if (filters.page) {
      params.page = filters.page;
    }

    if (filters.searchTerm) {
      params["filters[searchTerm]"] = filters.searchTerm;
    }

    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(
        ([, value]) => value !== undefined && value !== null && value !== "",
      ),
    );

    const response = await apiClient.get("/api/sale/product/v2/list", {
      params: filteredParams,
      ...(token
        ? {
            headers: {
              AuthorizationIntegrator: token,
            },
          }
        : {}),
    });

    return response.data;
  } catch (error) {
    console.error("Erro ao listar os produtos:", error);
    throw new Error("Erro ao listar os produtos");
  }
};

export const getProductById = async (id) => {
  try {
    const response = await apiClient.get(`/api/sale/product`, {
      params: { id },
    });
    return response.data;
  } catch (error) {
    console.error("Erro ao obter o produto pelo ID:", error);
    throw new Error("Erro ao obter o produto");
  }
};

export const uploadProductImages = async ({ productId, images, imageIndex }) => {
  try {
    if (!images || !Array.isArray(images) || images.length === 0) {
      return;
    }
    const formData = new FormData();
    formData.append("image", images[0]);
    if (typeof imageIndex !== "undefined") {
      formData.append("imageIndex", imageIndex);
    }
    // O axios define o boundary do multipart automaticamente a partir do FormData.
    const response = await apiClient.post(
      `/api/sale/product/${productId}/picture`,
      formData,
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao fazer upload das imagens:", error);
    throw new Error("Erro ao fazer upload das imagens");
  }
};

/**
 * Faz upload de múltiplas imagens (campo "pictures") a partir de um FormData
 * já montado pelo componente. O axios define o boundary automaticamente.
 */
export const uploadProductPicturesForm = async (productId, formData) => {
  const response = await apiClient.post(
    `/api/sale/product/${productId}/picture`,
    formData,
  );
  return response.data;
};

export const getProductPictures = async (productId) => {
  const response = await apiClient.get(
    `/api/sale/product/${productId}/pictures`,
  );
  return response.data;
};

export const deleteProductImages = async (ids) => {
  const response = await apiClient.delete("/api/sale/product/pictures", {
    data: { ids },
  });
  return response.data;
};

export const deleteProduct = async (id) => {
  try {
    const response = await apiClient.delete(`/api/sale/product/${id}`);
    return response.data;
  } catch (error) {
    console.error("Erro ao deletar o produto:", error);
    throw new Error("Erro ao deletar o produto");
  }
};

export const updateProductStatus = async (id, status) => {
  try {
    const response = await apiClient.put(`/api/sale/product/update-status`, {
      id,
      status,
    });
    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar status do produto:", error);
    throw new Error("Erro ao atualizar status do produto");
  }
};

/**
 * GET /api/sale/product/convenience-fees?pointOfSaleId=...
 *
 * Resposta esperada (corpo): { success, error, response: { convenienceFees: [...] } }
 * Cada item: paymentTypeId, percentage, fixedRate (strings).
 * - paymentTypeId === null  → taxa Menuus
 * - paymentTypeId !== null  → taxa gateway
 */
export const getConvenienceFees = async (pointOfSaleId) => {
  const response = await apiClient.get(`/api/sale/product/convenience-fees`, {
    params: { pointOfSaleId },
  });

  return response.data;
};

/**
 * PUT /api/sale/product/cross-sell/positions
 * items: [{ productId, position }]
 */
export const updateCrossSellPositions = async (pointOfSaleId, items) => {
  const response = await apiClient.put(`/api/sale/product/cross-sell/positions`, {
    pointOfSaleId,
    items,
  });
  return response.data;
};

export const listCategoriesByPointOfSaleId = async (pointOfSaleId) => {
  try {
    const response = await apiClient.get(
      `/api/sale/product-category/list/${pointOfSaleId}`,
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao listar as categorias:", error);
    throw error;
  }
};

export default {
  createProduct,
  listProducts,
  getProductById,
  uploadProductImages,
  deleteProduct,
  updateProductStatus,
  getConvenienceFees,
  updateCrossSellPositions,
};
